import { Status } from "@common/models";
import { Section } from "./section";

export class Process {
    id: Number;
    name: String;
    nameEnglish?: string;
    description: String;
    parent: Process;
    status: Status;
    sections?: Section[];
    createdAt: Date;
    createdUserId: Number;
    updatedAt: Date;
    updatedUserId: Number;
}
